import React, { useEffect, useState } from 'react';
import { adminGetCompanyByUserId } from '../../../api/appUsersApi';
import CompanyProfileContent from '../../../company-profile/components/CompanyProfileContent';
import './styles/UserCompanyProfile.css';

const UserCompanyProfile = ({ user }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [company, setCompany] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchCompany = async () => {
      if (!user?.id) {
        if (isMounted) {
          setError('User information not available');
          setLoading(false);
        }
        return;
      }

      setLoading(true);
      setError('');

      try {
        const result = await adminGetCompanyByUserId(user.id);

        if (!isMounted) {
          return;
        }

        if (result.exists) {
          setCompany(result.company);
        } else {
          setCompany(null);
          setError('No company found for this user');
        }
      } catch (err) {
        console.error('Error fetching company profile:', err);
        if (isMounted) {
          setError(err?.message || 'Failed to load company profile');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchCompany();

    return () => {
      isMounted = false;
    };
  }, [user?.id]);

  if (loading) {
    return (
      <div className="admin-card user-section-card userCompanyProfileCard" aria-busy="true">
        <div className="ucpHeader">
          <div>
            <h3 className="ucpTitle">Company Profile</h3>
            <p className="ucpSub">
              <span className="ucpSkeletonBar" style={{ width: 180, height: 14, display: 'inline-block' }} />
            </p>
          </div>
        </div>
        <div className="ucpSkeletonStack">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div className="ucpSkeletonBar" key={idx} style={{ width: '100%', height: 44, borderRadius: 12 }} />
          ))}
        </div>
      </div>
    );
  }

  if (!company) {
    return (
      <div className="admin-card user-section-card userCompanyProfileCard">
        <div className="ucpHeader">
          <div>
            <h3 className="ucpTitle">Company Profile</h3>
          </div>
        </div>
        <div className="ucpAlert ucpAlertError" role="alert">
          {error || 'No company found for this user.'}
        </div>
      </div>
    );
  }

  return (
    <div className="admin-card user-section-card userCompanyProfileCard">
        <div className="ucpHeader">
        <div>
          <h3 className="ucpTitle">Company Profile</h3>
          <p className="ucpSub">{company.name} · {company.id}</p>
        </div>
      </div>

      {error ? (
        <div className="ucpAlert ucpAlertError" role="alert">
          {error}
        </div>
      ) : null}

      <CompanyProfileContent
        company={company}
        onCompanyUpdated={setCompany}
        showCompanyId
        showHeader={false}
      />
    </div>
  );
};

export default UserCompanyProfile;
